import React from 'react';
import '../../configStyle_menuoption.css'

const ComponentOption = ({children}) => {


    return (
        <div id="component-option" className="text-gray-900 h-full">
            <div className="container pf-20">
                <div className=" sm:p-2 ">
                    {
                        children
                    }
                </div>
            </div>
        </div>
    );
}


export default ComponentOption;